import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventHeaderGroupSelection } from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventsGroupHeader6Pack.style';
import { Collapse } from 'src/ui/components/collapse/sports/03/Collapse';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface EventGroupHeaderPropsType {
    dataTest?: string;
    label: string;
    marketNames: [string, string, string];
    onToggle: () => void;
    open: boolean;
}

export const EventGroupHeader6Pack = observer('EventGroupHeader6Pack', (props: EventGroupHeaderPropsType) => {
    const { dataTest, label, open, marketNames, onToggle } = props;
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const configState = ConfigComponents.get(common).config;
    const isLabelsVisible = open && breakpointsState.desktop.isBiggerOrEq;

    return (
        <Collapse
            handleToggle={onToggle}
            isOpen={open}
            title={label}
            dataTest={dataTest}
        >
            {isLabelsVisible === true
                ? marketNames.map((marketName) => {
                      return (
                          <EventHeaderGroupSelection
                              key={marketName}
                              variant={configState.componentVariants.sportsbookVariant}
                          >
                              {marketName}
                          </EventHeaderGroupSelection>
                      );
                  })
                : null}
        </Collapse>
    );
});
